import { Route } from "react-router-dom";
import SignIn from "../pages/Authentication/SignIn";
import TwoStepVerification from "../pages/Authentication/TwoStepVerification";
import SelectBranch from "../pages/Authentication/SelectBranch";

/**
 * 📌 Rutas reales del flujo de autenticación
 *
 * Estas rutas se usan en el sistema:
 * - Inicio de sesión
 * - Verificación en dos pasos
 * - Selección de sucursal (usuarios con más de 1 sucursal asignada)
 */
const authRoutes = (
  <>
    <Route path="/auth/signin" element={<SignIn />} />
    <Route path="/auth/two-step-verification" element={<TwoStepVerification />} />
    <Route path="/auth/select-branch" element={<SelectBranch />} />
  </>
);

export default authRoutes;
